/* Libraries */
import dynamic from 'next/dynamic';
import { memo } from 'react';
import { LoaderComponent } from 'ht-styleguide';

/* Constants and Utils */
import { DEFAULT_TEXTS } from '@components/Searchbar/constants';

/* Dynamic components */
const SearchInputDynamic = dynamic(() => import('@components/Searchbar/SearchInput'), {
  ssr: false,
  loading: () => (
    <div style={{ paddingTop: '20px' }}>
      <LoaderComponent />
    </div>
  ),
});

/* Types */
type SearchBarProps = {
  onClose: $FixMe;
  searchClick: $FixMe;
  showSearchBar?: boolean;
  className?: string;
};

const SearchBar = ({ searchClick, onClose, className, ...props }: SearchBarProps) => (
  <>
    <SearchInputDynamic
      iconName="v2-close-icon"
      iconClick={onClose}
      location="Top nav search"
      placeholder={DEFAULT_TEXTS.PLACEHOLDER.topNavSearchText}
      {...props}
    />
    <style jsx>{`
      .nav_search_loader {
        top: 10px;
      }
    `}</style>
  </>
);

export default memo(SearchBar);
